import React, { useRef, useEffect } from "react"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import "./header-category.scss"

const HeaderCategory = ({ active, menu, mobile }) => {
  const tabContainer = useRef()

  useEffect(() => {
    if (tabContainer.current && mobile) {
      tabContainer.current.scrollIntoView()
    }
  }, [])

  const userInfoEncrypt= encryptUserInfo()
  return (
    <>
      <div className="f-header-category-scroll">
        <ul className="f-header-category">
          {menu.map((category, index) => {
            return (
              <li
                key={`${category}-${index}`}
                ref={category.titulo === active ? tabContainer : null}
                className={`f-header-item ${
                  category.titulo === active ? "f-header-item--active" : ""
                }`}
              >
                <a
                  className="f-header-item__link"
                  href={removeDoubleSlash("/productos/" + category.slug)}
                  onClick={() => {
                    pushDataLayerEvent({
                      'event':'Interacciones - Menu',
                      'category':'productos',
                      action: "click",
                      label: category.titulo,
                      sub_category: active,
                      location: window.location.href,
                      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                      log_status: userInfoEncrypt.log_status,
                    })
                  }}
                >
                  <h2 className="f-header-item__title">{category.titulo}</h2>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
      <div className="f-header-box-white" />
    </>
  )
}

export default HeaderCategory
